// libs
import { styled } from '@nykaa/ui-components';

// constants
import { MEDIA_BREAKPOINTS, DWEB_MAX_WIDTH } from 'shared/styles/base';

export const WidgetWrapper = styled.div`
  max-width: 100%;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.surface20};
`;

export const WidgetContainer = styled.div`
  max-width: ${DWEB_MAX_WIDTH}px;
  margin: 0 auto;
  padding: ${({ theme }) =>
    `0 ${theme.spacing.spacing120} ${theme.spacing.spacing40} ${theme.spacing.spacing120}`};

  ${MEDIA_BREAKPOINTS.TILL_TABLET_BIG} {
    padding: ${({ theme }) => `${theme.spacing.spacing20} ${theme.spacing.spacing100} 0`};
  }

  ${MEDIA_BREAKPOINTS.TILL_TABLET} {
    padding: ${({ theme }) => `${theme.spacing.spacing20} ${theme.spacing.spacing100} 0`};
  }

  ${MEDIA_BREAKPOINTS.MOBILE} {
    padding: 0;
  }
`;

export const WidgetHeader = styled.h2`
  padding: ${({ theme }) => `${theme.spacing.spacing160} 0 ${theme.spacing.spacing80}`};
  ${({ theme }) => theme.typography.titleLarge};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0 auto;

  ${MEDIA_BREAKPOINTS.TILL_TABLET} {
    ${({ theme }) => theme.typography.titleSmall};
    padding: ${({ theme }) =>
      `${theme.spacing.spacing80} 0 ${theme.spacing.spacing60} ${theme.spacing.spacing80}`};
  }
`;

export const CAVDesktopWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing.spacing160};
`;
